module.exports = __webpack_public_path__ + "static/majales-4290b0afd5bb0c688ce524ca6f3a99c6.svg";